import { Component, Input } from '@angular/core';
import { UserService } from '@ca/core/services';
import { Severity } from '@ca/core/models';

@Component({
    selector: 'ca-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent {
    @Input() title: string;
    @Input() text: string;
    @Input() severity: Severity = 'warn';
    constructor(private userService: UserService) {}

    get profileURL(): string {
        return `/user/profile/${this.userService.userSub}`;
    }
}
